// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { API_KEY } from "../configs/admin-config";

var idToken = null;
var userName = "";
var userRoles = [];
var encodeValue = null;
var userEmail = null;
var userPrivileges = [];
var employeeEmails = [];
var accessToken = null;
var refreshToken = null;
var refreshTokenFunction = null;
var sessionClearFunction = null;
var getNewTokenTries = 0;
var tokenRefreshRequests = [];

var isLoggedOut = false;

export function setIsLoggedOut(status) {
  isLoggedOut = status;
}

export function getIsLoggedOut() {
  return isLoggedOut;
}

export function setIdToken(token) {
  idToken = token;
}

export function getIdToken() {
  return idToken;
}

export function setAccessToken(token) {
  accessToken = token;
}

export function setUserName(user) {
  userName = user;
}

export function getUserName() {
  return userName;
}

export const setEncodeValue = (value) => {
  if (value) {
    encodeValue = value;
  }
};

export const getEncodValue = () => {
  return encodeValue;
};

export const setUserEmail = (email) => {
  userEmail = email;
};

export const getUserEmail = () => {
  return userEmail;
};

export const getAPIKey = () => {
  return API_KEY;
};

export function setUserPrivileges(privileges) {
  userPrivileges = privileges;
}

export function getUserPrivileges() {
  return userPrivileges;
}

export function setEmployeeEmails(emails) {
  employeeEmails = emails;
}

export function getEmployeeEmails() {
  return employeeEmails;
}

export function setUserRoles(rolesFromJWT) {
  if (typeof rolesFromJWT === "string") {
    userRoles = rolesFromJWT.split(",");
  } else if (Array.isArray(rolesFromJWT)) {
    userRoles = rolesFromJWT.slice();
  }
}

export function getUserRoles() {
  return userRoles;
}

export async function handleTokenFailure(callback) {
  tokenRefreshRequests.push(callback);
  if (tokenRefreshRequests.length === 1) {
    try {
      await refreshTokenFunction();
      let callbacksToRun = tokenRefreshRequests.slice();
      callbacksToRun.forEach((e) => {
        let callbackFn = tokenRefreshRequests.shift();
        callbackFn && callbackFn();
      });
    } catch (e) {
      console.error("Could not refresh access token!", e);
      sessionClearFunction && sessionClearFunction();
    } finally {
      tokenRefreshRequests = [];
    }
  }
}

export function setRefreshTokenFunction(refreshFunction) {
  refreshTokenFunction = refreshFunction;
}

export function setSessionClearFunction(sessionClearFn) {
  sessionClearFunction = sessionClearFn;
}

export function getAccessToken() {
  return accessToken;
}

export const isAccessGranted = (privilegeArr) => {
  const userPrivileges = getUserPrivileges();
  let isAccessGranted = false;

  for (let privilegeId of privilegeArr) {
    if (userPrivileges.includes(privilegeId)) {
      isAccessGranted = true;
      break;
    }
  }
  return isAccessGranted;
};

function setRefreshToken(token) {
  refreshToken = token;
}

export function getRefreshToken() {
  return refreshToken;
}

export function checkIfRoleExists(roleName) {
  var toReturn = userRoles.find((role) => {
    return role.trim() === roleName;
  });
  return Boolean(toReturn);
}
